import React, {useMemo} from 'react';
import {NavLink} from 'react-router-dom';
import {ReactComponent as Calendar} from 'assets/images/calendar.svg';
import {dateFormat, dateHoursFormat, timeFormat} from 'helpers/formats';
import {areDatesDayEqual} from 'helpers/utils';
import {AppRoutePaths} from 'routing/Routes';
import {ReservationDto} from '../../../../../PRMGApiClient';
import {useTranslation} from 'react-i18next';

interface ServiceBoxProps {
  reservation: ReservationDto;
  className?: string;
}

export const ReservationBox: React.FC<ServiceBoxProps> = ({
  reservation: {id, customer, begins: startDate, ends: endDate},
}) => {
  const {t} = useTranslation();

  const date = useMemo(() => {
    if (areDatesDayEqual(startDate, endDate)) {
      return `${dateFormat(startDate)} | ${timeFormat(startDate)} - ${timeFormat(endDate)}`;
    } else {
      return `${dateHoursFormat(startDate)} - ${dateHoursFormat(endDate)}`;
    }
  }, [startDate, endDate]);

  return (
    <NavLink to={AppRoutePaths.reservation.url + `/${id}`}>
      <div className="flex flex-col gap-2 p-2 border border-gray rounded-lg w-full hover:shadow-lg hover:scale-125 hover:cursor-pointer">
        <div className="flex justify-between">
          <h3 className="text-black font-semibold">
            {t('Reserved by: ')}
            {customer?.companyName ?? `${customer?.firstName} ${customer?.lastName}`}
          </h3>
        </div>

        <div className="flex gap-2 items-center">
          <Calendar className="h-4 w-4" />
          <span className="text-12 leading-4 text-darkGray">{date}</span>
        </div>
      </div>
    </NavLink>
  );
};
